import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";

export function useCapturePlacesTree(capturePlacesService, treeLaneCheckedStatus) {
    const {
        data: capturePlaces = [],
        isLoading,
        status,
        refetch
    } = useQuery({
        queryKey: ["capture-places"],
        queryFn: async () => {
            const data = await capturePlacesService.listAllowed();

            return data.map((passage, indexPassage) => ({
                key: String(indexPassage),
                parentKey: null,
                label: passage.description,
                children: passage.routes.map((route, indexRoute) => ({
                    key: `${indexPassage}-${indexRoute}`,
                    parentKey: String(indexPassage),
                    label: route.description,
                    data: { regionType: route.regionType },
                    children: route.lanes.map((lane, indexLane) => ({
                        key: `${indexPassage}-${indexRoute}-${indexLane}`,
                        parentKey: `${indexPassage}-${indexRoute}`,
                        label: `${lane.code} - ${route.description}`,
                        code: lane.code
                    }))
                }))
            }));
        }
    });

    const checkedInitialState = useMemo(() => {
        if (!capturePlaces.length) return {};

        const acc = {};
        capturePlaces.forEach(node => getAllNodesAsChecked(node, acc));
        return acc;
    }, [capturePlaces]);

    const inputCamerasValue = useMemo(() => {
        const arr = Object.values(treeLaneCheckedStatus);
        const selected = arr.filter(el => el.code && el.checked);
        const result = {label: "", values: selected};

        if (selected.length > 2) result.label = `${selected.length} selecionadas`;
        else result.label =  selected.map(el => el.label).join(", ");

        return result
        }, [treeLaneCheckedStatus]);

    return {
        nodes: capturePlaces,
        checkedInitialState,
        isLoading,
        status,
        refetch,
        inputCamerasValue
    };
}

function getAllNodesAsChecked(node, acc = {}) {
    acc[node.key] = {
        checked: true,
        partial: false,
        parentKey: node.parentKey ?? null,
        children: node.children?.map(el => el.key) ?? []
    };

    if (node.code) {
        acc[node.key].code = node.code;
        acc[node.key].label = node.label;
    }

    node.children?.forEach(child =>
        getAllNodesAsChecked(child, acc)
    );

    return acc;
}